import { useMotionValue, AnimationPlaybackControls, animate, motion } from "framer-motion";
import { useRef, useEffect } from "react";
import useMeasure from "react-use-measure";
import CardsContainer from "./CardsContainer";

const Carousel: React.FC = () => {
    let [ref, { width }] = useMeasure();
    const xTranslation = useMotionValue(0);

    let animationRef = useRef<AnimationPlaybackControls>(null);
  
    useEffect(() => {
      let finalPosition = -width;
  
      let animation = animate(xTranslation, [0, finalPosition], {
        ease: "linear",
        duration: 25,
        repeat: Infinity,
        repeatType: "loop",
        repeatDelay: 0,
      })
  
      animationRef.current = animation
      return () => animation?.stop();
    }, [xTranslation, width])
  
    return (
      <motion.div className="container carousel-container">
          <motion.div className="carousel" style={{x: xTranslation}}>
            <CardsContainer animationRef={animationRef} ref={ref}/>
            <CardsContainer animationRef={animationRef} />
        </motion.div>
      </motion.div>
    )
};

export default Carousel;